import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HomeClassic from '../pages/HomeClassic/HomeClassic';
import { getLocaleFromPath } from '../config/localeRoutes';

/** Hub /en (et futurs /xx) : accueil + langue UI alignée sur le préfixe. */
export default function LocalePrefixedHome() {
  const { i18n } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    const pathLocale = getLocaleFromPath(pathname);
    if (pathLocale && i18n.language !== pathLocale) {
      void i18n.changeLanguage(pathLocale);
    }
  }, [i18n, pathname]);

  return <HomeClassic />;
}
